import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewChild, TemplateRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '../../services/commonservice';
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid/isg-grid.component';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import OktaAuth, { extend } from '@okta/okta-auth-js';
import { BaseHttpReqRespService } from '../../../../modules/fwcore/services';
import { OKTA_AUTH } from '@okta/okta-angular';
import { API_ENDPOINTS } from '@mysrc/app/api-endpoints';

@Component({
  selector: 'app-page-slider-question',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    IsgGridComponent,
    NgbAccordionModule
  ],
  templateUrl: './page-slider-question.component.html',
  styleUrl: './page-slider-question.component.scss',
  providers: [CommonService]
})

export class PageSliderQuestionComponent extends BaseHttpReqRespService {
  private gridApi!: any;
  public rowIndex: string = "";
  public tmpMappingId: number = 0;
  public schemaDetail!: gradingSchemaDetails;
  public schemaDetailList: gradingSchemaDetails[] = [];
  public popupSchemaList: gradingSchemaDetails[] = [];
  public gradingSchemaList: gradingSchema[] = [];
  public oktaTokenDetails!: oktaToken;

  public type: string = "Slider";
  public schemaId: number = 0;
  public questionDescription: string = "";
  public schemaName: string = "";

  defRangeValue: number = 0;

  public questionCategoryId: number = 0;
  public questionCategoryList: questionCategory[] = [];
  QUESTION_ENDPOINT = API_ENDPOINTS.QUESTION;
  SURVEY_ENDPOINT = API_ENDPOINTS.SURVEY;
  public serviceList!: Service[];

  myAppUrl: any;
  public questionId!: number;
  public folderId!: number;
  public folderName!: string;
  sliderForm!: FormGroup;
  selectGSchemaForm!: FormGroup;
  createEditSchemaForm!: FormGroup;
  quesCategoryForm!: FormGroup;

  public redirectedSectionId!: number;
  public redirectedSurveyId!: number;
  successOrFailureMessage: string = '';

  showTitlePanel: boolean = true;
  showSchemaPanel: boolean = false;
  @ViewChild('CreateUpdateQsCategoryModal') categoryModal!: TemplateRef<any>;
  @ViewChild('createEditGSchema') createEditGSchemaModal!: TemplateRef<any>;
  @ViewChild('deleteConfirmation') deleteConfirmationModal!: TemplateRef<any>;

  schemaDetailGridConfig: Partial<IsgGridConfig> = {
    height: '250px',
    pagination: false,
  };

  popupSchemaGridConfig: Partial<IsgGridConfig> = {
    height: '250px',
    pagination: false,
  };

  constructor
    (@Inject(OKTA_AUTH) private oauth: OktaAuth,
      @Inject('BASE_URL') baseUrl: string,
      @Inject('CONFIG_SETTINGS') configSettings: any,
      private _router: Router,
      public http: HttpClient,
      private formBuilder: FormBuilder,
      private commonService: CommonService,
      private renderer: Renderer2,
      private route: ActivatedRoute,
      private EncrDecr: EncrDecrService,
      private modalService: NgbModal
    ) {
    super(http, oauth);
    const genSettings = configSettings[<any>'general'];
    this.myAppUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl += '/';
  }
  backUrl() {
    if (this.folderId == -1)
      this._router.navigate(['/question']);
    else
      this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
  }


  ngOnInit() {
    this.questionId = +this.route.snapshot.queryParams["questionId"];
    this.folderId = this.route.snapshot.queryParams["folderId"];
    this.folderName = this.route.snapshot.queryParams["folderName"];
    this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
    this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];

    this.sliderForm = this.formBuilder.group({
      'description': new FormControl(null, Validators.required),
      'defRangeValue': new FormControl(null, null),
      'schemaId': new FormControl(null, Validators.required),
      'createdBy': new FormControl(null, null),
      'modifiedBy': new FormControl(null, null),
      'questionId': new FormControl(null, null),
      'folderId': new FormControl(null, null),
      'type': new FormControl(null, null),
      'questionCategoryId': new FormControl(null, null),
      'shortName': new FormControl(null, null)
    });

    this.selectGSchemaForm = this.formBuilder.group({
    });

    this.createEditSchemaForm = this.formBuilder.group({
      'minRangeValue': new FormControl(null, Validators.required),
      'maxRangeValue': new FormControl(null, Validators.required),
      'rangeDescription': new FormControl(null, Validators.required),
      'schemaName': new FormControl(null, Validators.required),
      'weightage': new FormControl(null, Validators.required),
      'gradingSchemaDetailsList': new FormControl(null, null),
      'createdBy': new FormControl(null, null),
      'modifiedBy': new FormControl(null, null),
    });

    this.quesCategoryForm = this.formBuilder.group({
      'quesCategoryName': new FormControl(null, Validators.required)
    });

    this.getQuestion();
    this.getQuestionCategoryList();
    this.getGradingSchemaList();

  }

  getQuestionCategoryList() {
    this.commonService.httpGet("", this.myAppUrl + this.QUESTION_ENDPOINT.QUESTION_CATEGORY_LIST).subscribe(result => {
      this.questionCategoryList = result;
    }, error => console.error(error));

  }

  AddQuesCategory() {
    let tmpQuesCategoryName = this.quesCategoryForm?.get('quesCategoryName')?.value ?? "";
    let resourceIdList = "quesCategoryName=" + tmpQuesCategoryName;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(resourceIdList, this.myAppUrl + this.QUESTION_ENDPOINT.SAVE_CATEGORY, httpOptions).subscribe(result => {
      this.getQuestionCategoryList();
    }, error => console.error(error));
  }

  ResetQuesCategoryForm() {
    this.quesCategoryForm.reset();
  }

  openModal() {
  }

  onCategoryChange() {

  }

  onSchemaChange() {
    const schemaId = this.sliderForm.get('schemaId')?.value ?? 0;
    this.commonService.httpGet('', this.myAppUrl + this.QUESTION_ENDPOINT.GRADING_SCHEMA + '/' + schemaId
    ).subscribe(
      result => {
        this.schemaDetailList = result.gradingSchemaDetailsList;
      },
      err => {
        console.log("Error- something is wrong!" + err.status + err.message)
      });
  }

  AddUpdateGradingDetail(params: any) {
    this.AddGradingDetail();
  }

  AddGradingDetail() {
    let rowCount = this.gridApi.getDisplayedRowCount();
    this.schemaName = this.createEditSchemaForm.get('schemaName')?.value ?? '';
    let tmpMaxRange = this.createEditSchemaForm.get('maxRangeValue')?.value ?? 0;
    let tmpMinRange = this.createEditSchemaForm.get('minRangeValue')?.value ?? 0;
    let weightage = this.createEditSchemaForm.get('weightage')?.value ?? 0;
    let isValid = false;
    if (tmpMaxRange > tmpMinRange) {
      if (this.popupSchemaList.length > 0) {
        let tmpArray = this.popupSchemaList[this.popupSchemaList.length - 1];
        if (tmpMinRange > tmpArray.maxRange) {
          isValid = true;
        }
        else {
          //return false;
          return;
        }
      }
      else {
        isValid = true;
      }
    }
    else {
      //return false;
      return;
    }

    if (isValid) {
      this.schemaDetail = {
        maxRange: this.createEditSchemaForm.get('maxRangeValue')?.value ?? 0,
        minRange: this.createEditSchemaForm.get('minRangeValue')?.value ?? 0,
        rangeDescription: this.createEditSchemaForm.get('rangeDescription')?.value ?? '',
        weightage: this.createEditSchemaForm.get('weightage')?.value ?? 0,
        mappingId: ++rowCount,
        comments: '',
        schemaId: 0,
        technologyAnswerYes: '',
        technologyAnswerNo: ''
      };
      var newItem = this.schemaDetail;
      // Update grid data for ag-Grid Community
      this.popupSchemaList.push(this.schemaDetail);
      this.gridApi.setRowData(this.popupSchemaList);
      // Trigger change detection by creating a new array reference
      this.popupSchemaList = [...this.popupSchemaList];
      this.createEditSchemaForm.reset();
      this.createEditSchemaForm.patchValue({
        schemaName: this.schemaName
      });
    }
  }

  DeleteGradingDetail() {
    var selected = this.gridApi.getFocusedCell();
    this.rowIndex = selected.rowIndex;
    let currentRow = this.gridApi.getRowNode(this.rowIndex);
    // Remove from popupSchemaList and update grid
    this.popupSchemaList = this.popupSchemaList.filter(item => item.mappingId !== currentRow.data.mappingId);
    this.gridApi.setRowData(this.popupSchemaList);
  }

  UpdateGradingDetail() {
    this.schemaDetail = {
      maxRange: this.createEditSchemaForm.get('maxRangeValue')?.value ?? 0,
      minRange: this.createEditSchemaForm.get('minRangeValue')?.value ?? 0,
      rangeDescription: this.createEditSchemaForm.get('rangeDescription')?.value ?? '',
      weightage: this.createEditSchemaForm.get('weightage')?.value ?? 0,
      mappingId: this.tmpMappingId,
      comments: '',
      schemaId: 0,
      technologyAnswerYes: '',
      technologyAnswerNo: ''
    };
    var newItem = this.schemaDetail;
    let updateItem = this.schemaDetailList.find(x => x.mappingId === this.tmpMappingId);
    if (updateItem) {
      let index = this.schemaDetailList.indexOf(updateItem);
      this.schemaDetailList[index] = newItem;
    }
    this.ResetValue();
  }

  findIndexToUpdate(newItem: any) {
    return newItem.id === this;
  }

  onSchemaDetailsGridReady(params: any) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
  }

  saveSchemaDetails() {
    this.createEditSchemaForm.patchValue({
      gradingSchemaDetailsList: this.popupSchemaList,
      createdBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      modifiedBy: this.EncrDecr.get(localStorage.getItem('userId') ?? "")
    });


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    let data = JSON.stringify(this.createEditSchemaForm.value);

    //this.http.post<any>(this.oktaTokenDetails.apiHostName + '/' + this.QUESTION_ENDPOINT.UPSERT_GRADING_SCHEMA, data, options)
    //  .subscribe(

    this.commonService.httpPostWOHeader(
      this.myAppUrl + this.QUESTION_ENDPOINT.UPSERT_GRADING_SCHEMA, data, httpOptions
    ).subscribe(
      result => {
        //alert(result);
        this.getGradingSchemaList();
        //this.showMessage(result.message);
        //this.messageTimeout();
      },
      err => {
        console.log("Error- something is wrong!" + err.status + err.message)
      });

  }

  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "block";

    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = params;
    }
  }

  saveSliderQuestion() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };

    // Ensure defRangeValue is a number
    let defRangeValue = this.sliderForm.get('defRangeValue')?.value;
    defRangeValue = defRangeValue ? Number(defRangeValue) : 0;

    // Build payload as root object
    const objQuestion = {
      ...this.sliderForm.value,
      defRangeValue: defRangeValue,
      createdBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      modifiedBy: this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      questionId: this.questionId,
      folderId: this.folderId,
      type: this.type
    };

    const data = JSON.stringify(objQuestion); // Send as root object

    this.commonService.httpPostWOHeader(
      this.myAppUrl + this.QUESTION_ENDPOINT.SAVE, data, httpOptions
    ).subscribe(
      questionId => {
        this.redirectedSectionId = this.route.snapshot.queryParams["redirectedSectionId"];
        this.redirectedSurveyId = this.route.snapshot.queryParams["redirectedSurveyId"];
        this.showMessage("Question Saved Successfully.");
        setTimeout(() => {
          this.showMessage('');
          this.folderId = + this.route.snapshot.queryParams["folderId"];
          this.folderName = this.route.snapshot.queryParams["folderName"];
          var location = window.location.pathname;
          if (location.includes("/client") == false) {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }
          else {
            if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
              this.mapQuestionsToSection(questionId, this.redirectedSurveyId, this.redirectedSectionId)
              this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
            } else {
              if (this.folderId > 0)
                this._router.navigate(['viewquestions'], { queryParams: { questionReference: this.folderId, question: this.folderName } });
              else
                this._router.navigate(['question']);
            }
          }

        }, 2000);
      },
      err => {
        console.log("Error- something is wrong!" + err.status + err.message)
      });

  }

  BackUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      let fId = this.folderId;
      let fName = this.folderName;
      if (fId > 0)
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: fId, question: fName } });
      else
        this._router.navigate(['question']);
    }
    else {
      this._router.navigate(['/programoverview']);
    }
  }

  onQuestionGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }

  columnDefs: ColDef[] = [
    { headerName: 'SchemaId', field: 'schemaId', hide: true },
    { headerName: 'MappingId', field: 'mappingId', hide: true },
    { headerName: 'Description', field: 'rangeDescription', resizable: true },
    { headerName: 'Min Score', field: 'minRange', resizable: true },
    { headerName: 'Max Score', field: 'maxRange', resizable: true },
    { headerName: 'Weightage', field: 'weightage', resizable: true }
  ];

  colDefsGradingSchema: ColDef[] = [
    { headerName: '', field: 'rowSelect', width: 40, suppressMenu: true, sortable: false, checkboxSelection: true, headerCheckboxSelection: true, resizable: true },
    { headerName: 'SchemaId', field: 'schemaId', hide: true },
    { headerName: 'Schema Name', field: 'schemaName', width: 420, resizable: true },
  ];

  colDefsSchemaDetails: ColDef[] = [
    { headerName: 'MappingId', field: 'mappingId', hide: true, width: 0 },
    { headerName: 'Description', field: 'rangeDescription', width: 240, resizable: true },
    { headerName: 'Min Score', field: 'minRange', width: 200, resizable: true },
    { headerName: 'Max Score', field: 'maxRange', width: 200, resizable: true },
    { headerName: 'Weightage', field: 'weightage', width: 200, resizable: true },
    { headerName: 'Delete', field: '', cellRenderer: this.deleteLinkRenderer.bind(this), width: 200, resizable: true }
  ];

  editLinkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    this.renderer.addClass(element, "fa");
    this.renderer.addClass(element, "fa-edit");
    this.renderer.setAttribute(element, 'id', params.data.mappingId);
    this.renderer.listen(element, 'click', () => {
      let parameter = "?mappingId=" + params.data.mappingId;

      this.createEditSchemaForm.patchValue({
        minRangeValue: params.data.minRange,
        maxRangeValue: params.data.maxRange,
        rangeDescription: params.data.rangeDescription,
        weightage: params.data.weightage,
        mappingId: params.data.mappingId,
        comments: null,
        schemaId: 0,
        technologyAnswerYes: null,
        technologyAnswerNo: null
      });

    });
    //this.tmpMappingId = params.data.mappingId;
    return element;
  }

  deleteLinkRenderer(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.setStyle(element, 'cursor', 'pointer');
    this.renderer.listen(element, 'click', () => {
      this.rowIndex = params.node.rowIndex;
      this.openDeleteConfirmationModal();
    });
    return element;
  }

  onRowSelected(params: any) {

  }

  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 1800);
  }
  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) {
      divMessage.style.display = "none";
    }
    var message = document.getElementById('message');
    if (message) {
      message.innerText = '';
    }
  }


  getGradingSchemaList() {
    const workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? "")
    this.commonService.httpGet('', this.myAppUrl + this.QUESTION_ENDPOINT.GRADING_SCHEMA_LIST + '/' + workspaceId
    ).subscribe(
      result => {
        this.gradingSchemaList = result;
      },
      err => {
        console.log("Error- something is wrong!" + err.status + err.message)
      });

    this.hideMessage();
  }


  getQuestion() {
    if (this.questionId > 0) {
      let options = {
        params: {
          questionId: this.questionId.toString()
        }
      }
      var model = "?questionId=" + this.questionId;
      this.http.post<any>(this.oktaTokenDetails.apiHostName + '/' + this.QUESTION_ENDPOINT.GET_QUESTION, null, options)
        .subscribe(
          result => {
            this.schemaDetailList = result.schemaDetailList;
            this.sliderForm.patchValue({
              description: result.description,
              defRangeValue: result.defRangeValue,
              schemaId: result.schemaId,
              schemaDetailList: this.schemaDetailList,
              gradingSchemaList: this.gradingSchemaList,
              questionId: result.questionId,
              questionCategoryId: result.questionCategoryId,
              shortName: result.shortName
            });
          },
          err => {
            console.log("Error- something is wrong!" + err.status + err.message)
          });
    }

  }

  ResetValue() {
    this.sliderForm.reset();
    this.createEditSchemaForm.reset();
  }

  ResetValueSchemaPopup() {
    this.createEditSchemaForm.reset();
    this.popupSchemaList = [];
  }
  mapQuestionsToSection(questionid: any, surveyId: any, currentSectionId: any) {
    var concatenated = questionid.toString();

    let questionIdList = "questionIdList=" + concatenated + "&surveyId=" + surveyId + "&sectionId=" + currentSectionId;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    this.commonService.httpPost(questionIdList, this.myAppUrl + this.SURVEY_ENDPOINT.MAP_QUESTION_TO_SECTION, httpOptions).subscribe(
      result => {
        window.setTimeout(() => {
          this.successOrFailureMessage = '';
        }, 1200);
      },
      (error: any) => console.error(error)
    );

  }
  BackToSectionUrl() {
    var location = window.location.pathname;
    if (location.includes("/client") == false) {
      if (this.redirectedSectionId >= 0 && this.redirectedSurveyId >= 0) {
        this._router.navigate(['/survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
      }
    }
    else {
      this._router.navigate(['/clientadmin-survey-questionnaire'], { queryParams: { 'surveyId': this.redirectedSurveyId, 'sectionId': this.redirectedSectionId } });
    }
  }
  openCategoryModal() {
    if (this.categoryModal) {
      this.modalService.open(this.categoryModal);
    }
  }

  openCreateSchemaModal() {
    if (this.createEditGSchemaModal) {
      this.modalService.open(this.createEditGSchemaModal, { size: 'lg' });
    }
  }

  openDeleteConfirmationModal() {
    if (this.deleteConfirmationModal) {
      this.modalService.open(this.deleteConfirmationModal);
    }
  }
}

interface gradingSchemaDetails {
  mappingId: number;
  schemaId: number;
  weightage: any;
  minRange: any;
  maxRange: any;
  rangeDescription: string;
  comments: string;
  technologyAnswerYes: string;
  technologyAnswerNo: string;
}
interface gradingSchema {
  schemaId: number;
  schemaName: string;
  createdBy: number;
  modifiedBy: number;
  createdDate: string;
  modifiedDate: string;
  //gradingSchemaDetailsList: gradingSchemaDetails[];
}
interface questionCategory {
  questionCategoryId: number;
  questionCategoryName: string;
}
interface oktaToken {
  accessToken: string;
  apiHostName: string;
}

interface Service {
  serviceId: number;
  serviceName: string;
}

